<template>
    <v-btn
        v-if="ycHrefInfo && isAltegio"
        class="svg-icon"
        icon
        @click="openInNewTab(getLink(ycHrefInfo))"
        :style="`width:${btnWidth}px;height:${btnHeight}px`"
    >
        <v-icon :size="size" color="mainNew">{{ '$vuetify.icons.altegio' }}</v-icon></v-btn
    >
</template>

<script>
import { crmLinkService } from '@root/src/helpers/crmLinks'
import { openInNewTab } from '@root/src/utils'
import { CONNECTOR_TYPES } from '@root/src/vars/general'

export default {
    name: 'AltegioLink',
    components: {},
    props: {
        hrefInfo: {
            type: Array,
            default: () => [],
        },
        size: {
            type: Number,
            default: 18,
        },
        btnWidth: {
            type: Number,
            default: 36,
        },
        btnHeight: {
            type: Number,
            default: 36,
        },
    },
    data: () => ({}),
    computed: {
        project() {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        isAltegio() {
            return this.project.connectors.find(el => el.connectorType === CONNECTOR_TYPES.yClients)?.isAltegio
        },
        ycHrefInfo() {
            return this?.hrefInfo?.find(el => el.connectorType === CONNECTOR_TYPES.yClients)
        },
    },
    methods: { openInNewTab, getLink: crmLinkService.getAltegioLink },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'
</style>
